<template>
  <div>
    <!-- 服务单拆分 -->
    <el-dialog :title="$t('message.serviceOrderSplit')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1868px" center>
      <div class="content">
        <!-- 服务单号 -->
        <div class="head">

          <div class=" row">
            <!-- 服务操作人 -->
            <div class="value">
              <el-select v-model="datas.adminId" clearable :placeholder="$t('message.serviceOperator')" filterable>
                <el-option v-for="item in adminLis" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 要求完成时间 -->
            <div class="value">
              <el-date-picker v-model="datas.need_complete_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('message.requiredCompletionTime')">
              </el-date-picker>
            </div>
            <!-- 服务单类型 -->
            <div class="value">
              <el-select v-model="datas.cate_id" clearable :placeholder="$t('message.serviceOrderType')" filterable>
                <el-option v-for="item in cateList" :key="item.cate_id" :label="item.cate_name" :value="item.cate_id">
                </el-option>
              </el-select>
            </div>

          </div>
          <!-- 服务操作人 -->
          <div class="quantityStatistics">
            <!--总计需要操作  -->
            <p>{{ $t("message.totalNeedToOperate") }}</p>
            <div class="total">
              <div class="item" v-for="(item, index) in total" :key="index">
                {{ item.name }}：
                <span>{{ item.should }}</span>
              </div>

            </div>
          </div>
        </div>

        <div class="table">
          <ol>
            <!-- 番号 -->
            <li class="flex05">
              <el-checkbox v-model="checked" @change="allCheckedChange">
              </el-checkbox>
            </li>
            <!-- 订单号 -->
            <li class="flex15">{{ $t("message.orderNumber") }}</li>
            <!-- 番号 -->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>
            <!-- 照片 -->
            <li>{{ $t("message.pic") }}</li>
            <!-- 业务编辑商品属性 -->
            <li class="flex2">
              {{ $t("message.theBusinessEditsTheCommodityProperties") }}
            </li>
            <!-- 购买信息 -->
            <li>{{ $t("message.purchaseInformation") }}</li>
            <!-- 附加服务 -->
            <li class="flex2">
              {{ $t("message.additionalServices") }}
            </li>
            <!-- 担当备注 -->
            <li class="flex15">
              {{ $t("message.responsibleForRemarks") }}
            </li>
            <!-- 核查员备注 -->
            <li class="flex15">
              {{ $t("message.verifierSNotes") }}
            </li>
            <!-- 操作内容-需要操作数量-可提交操作数量 -->
            <li class="flex3">
              操作内容-拆分数量-可拆分数量
            </li>
            <!-- 检品组长备注 -->
            <li>
              {{ $t("message.inspectionLeaderRemark") }}
            </li>
            <!-- 操作人员备注 -->
            <li>
              {{ $t("message.operationPersonnelRemark") }}
            </li>
          </ol>
          <ul v-for="(item, index) in detail.detail" :key="index">
            <li class="flex05">
              <el-checkbox v-model="item.checked" @change="checkedChange">
              </el-checkbox>
            </li>
            <!-- 订单号 -->
            <li class="flex15">
              <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">
                {{ item.order_detail.order_sn }}
              </router-link>
            </li>
            <!-- 番号 -->
            <li class="flex05">
              {{ item.order_detail.sorting }}
            </li>
            <!-- 照片 -->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference">
                  <el-image :src="item.order_detail.pic" style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </li>
            <!-- 业务编辑商品属性 -->
            <li class="flex2">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.order_detail.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.order_detail.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 购买信息 -->
            <li>
              <div class="template">
                <p>数量：{{ item.order_detail.confirm_num }}
                </p>
                <p>单价：{{ item.order_detail.confirm_price }}</p>
              </div>
            </li>
            <!-- 附加服务 -->
            <li class="flex2">
              <div class="template">
                <el-tooltip placement="bottom" style="max-height: 100px">
                  <div slot="content">
                    <div class="row" v-for="(opti, optiIndex) in item.order_detail.option" :key="optiIndex"
                      style="margin-bottom: 3px">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(opti, optiIndex) in item.order_detail.option" :key="optiIndex">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 担当备注 -->
            <li class="flex15">
              <p> {{ item.order_detail.y_remark }}</p>
            </li>
            <!-- 核查员备注 -->
            <li class="flex15">
              <p> {{ item.order_detail.p_remark }}</p>
            </li>
            <li class="flex3">
              <div class="template option">
                <div class="row" v-for="(extra, extraIndex) in item.extra_options" :key="extraIndex">
                  <div class="label">{{ extra.name }}:</div>
                  <div class="input">
                    <el-input v-model="extra.should" placeholder="数量" @input="handleInput(extra)"></el-input>
                  </div>

                  <div class="num">{{ extra.should_total }}</div>
                </div>
              </div>
            </li>
            <!-- 检品组长备注，拆分创建时随服务单数据一并提交。 -->
            <li>
              <el-input v-model="item.leader_remark" :placeholder="$t('message.inspectionLeaderRemark')"
                type="textarea"></el-input>
            </li>
            <!-- 操作人员备注，拆分创建时随服务单数据一并提交。 -->
            <li>
              <el-input v-model="item.mechanic_remark" :placeholder="$t('message.operationPersonnelRemark')"
                type="textarea"></el-input>
            </li>

          </ul>
        </div>
        <div class="btn">
          <!-- 提交给检品 -->
          <el-button type="primary" @click="splitStore(0)" v-if="isAuth(591)">
            {{ $t('message.submitToInspection') }}
          </el-button>
          <!-- 操作完了 -->
          <!-- <el-button type="success" @click="splitStore(1)" >
            {{ $t('message.operationCompleted') }}
          </el-button> -->
        </div>
        <!-- 底部 -->
        <div class="footer">
          <!-- 注意事项-->
          <div class="label">
            {{ $t('message.mattersNeedingAttention') }}:
          </div>
          <div class="text">
            <el-input type="textarea" v-model="datas.remark"></el-input>
          </div>
          <!-- 服务单附件： -->
          <div class="label">
            {{ $t('message.serviceOrderAttachment') }}:
          </div>
          <div class="file">
            <div class="file-list">
              <div class="item" v-for="(item, index) in datas.file" :key="index">
                <a :href="item" target="_blank" rel="noopener noreferrer" :title="item">
                  <i class="el-icon-folder-checked"></i>
                </a>
              </div>

            </div>
            <el-upload :action="baseURL + '/api/common/uploadFile'" :show-file-list="false" :http-request="httpup" drag>
              <el-button slot="trigger" type="primary">
                上传文件
              </el-button>
            </el-upload>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>


export default {
  components: {

  },

  data() {
    return {
      checked: false,//是否全选
      detail: {
        detail: []
      }, //服务单详情
      adminLis: [], //可选检品操作人员
      datas: {
        remark: '',
        file: [],
        adminId: '',
        need_complete_at: '',
        cate_id: '',
      },//服务单详情
      total: [], //服务单详情-总数
      dialogVisible: false,
      cateList: [],
      addIndex: 0,
      fba_name: '',
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.checked = false
        this.usableAdminList()
        this.$api.optionServiceApi.cateList().then(res => {
          this.cateList = res.data
        })
      }
    },
  },
  methods: {
    // 服务单-新增预览
    optionServicePreview(data) {
      let res = JSON.parse(JSON.stringify(data))
      this.detail.detail = []
      res.option_service_detail.forEach(item => {
        if (item.checked) {
          let newItem = JSON.parse(JSON.stringify(item))
          newItem.checked = false
          newItem.leader_remark = newItem.leader_remark || ''
          newItem.mechanic_remark = newItem.mechanic_remark || ''
          newItem.extra_options.forEach(extraItem => {
            extraItem.complete = 0
          })
          this.detail.detail.push(newItem)
          console.log(newItem);

        }
      })
      this.datas.remark = res.remark
      this.datas.cate_id = res.cate_id
      this.datas.need_complete_at = res.need_complete_at
      this.datas.file = res.file
      this.datas.source_service_sn = res.service_sn
      this.datas.adminId = ''
      this.calculateTotal()
    },
    //服务单-可选检品操作人员
    usableAdminList() {
      this.$api.optionServiceApi.usableAdminList().then(res => {
        this.adminLis = res.data
        let fba = res.data.find(item => item.realname == this.fba_name)
        if (fba) {
          this.datas.adminId = fba.id
          this.datas.cate_id = 5
        }
      })
    },
    // 计算总数
    calculateTotal() {
      this.total = []
      this.detail.detail.forEach(item => {
        item.extra_options.forEach(extraItem => {
          extraItem.should_total = extraItem.should
          extraItem.complete = 0

          let existingItem = this.total.find(totalItem => totalItem.name == extraItem.name)
          if (existingItem) {
            existingItem.should += extraItem.should - 0
          } else {
            this.total.push({
              name: extraItem.name,
              should: extraItem.should - 0
            })
          }
        })
      })
    },
    handleInput(item) {
      // 将输入值转换为数字，去除所有非数字字符
      let value = item.should.replace(/\D/g, '');
      // 如果输入为空，则清空
      if (value === '') {
        item.should = '';
      } else {
        // 转换为数字
        const number = parseInt(value, 10);
        // 确保是正整数
        if (isNaN(number) || number < 0) {
          item.should = '';
        } else {
          // 不能大于should值
          const maxShould = parseInt(item.should_total, 10) || 0;
          if (number > maxShould) {
            item.should = maxShould.toString();
          } else {
            item.should = number.toString();
          }
        }
      }
      this.$forceUpdate()
    },
    // 文件上传事件
    async httpup(file) {
      let data = await this.createClient(file)
      this.datas.file.push(data.data)
      this.$forceUpdate()
    },
    //新增服务单保存
    splitStore(type) {

      if (this.datas.adminId == '') return this.$message.error('未选择服务操作人')
      if (this.datas.need_complete_at == null) return this.$message.error('未选择服务完成时间')
      if (this.datas.cate_id == '') return this.$message.error('未选择服务分类')

      this.datas.serviceDetail = []
      let isExtra = false
      this.detail.detail.forEach(item => {
        if (item.extra_options.length == 0) {
          isExtra = true
        }
        this.datas.serviceDetail.push({
          id: item.id,
          leader_remark: item.leader_remark,
          mechanic_remark: item.mechanic_remark,
          extra_options: JSON.stringify(item.extra_options)
        })
      })

      if (this.datas.serviceDetail == false) return this.$message.error('提出的服务单数量不能全为0')
      this.$confirm(
        type == 0 ? '请确认服务单信息，数量无误后，再操作提出，拆分后无法进行修改。' : '是否提出当前服务单，并直接完成服务单，操作后服务单无法取消，请确认后操作',
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.optionServiceApi.splitStore(this.datas).then(res => {
            this.$message.success(res.msg)
            this.dialogVisible = false
            this.$parent.optionServiceList()
            this.$forceUpdate()
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 全选/取消全选
    allCheckedChange() {
      this.detail.detail.forEach(item => {
        item.checked = this.checked
      })
    },
    // 是否全选
    checkedChange() {
      this.checked = this.detail.detail.every(item => item.checked)
      this.$forceUpdate()
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  position: relative;

  .head {
    padding: 24px;
    background-color: #F6F6F6;
    margin-bottom: 24px;
    border-radius: 6px;
    font-size: 16px;
    color: #333333;

    .service_sn {
      display: flex;
      margin-bottom: 24px;
      display: flex;

      .value {
        color: #B4272D;
        margin-left: 10px;
      }
    }

    .row {
      display: flex;
      margin-bottom: 24px;
      line-height: 32px;
      position: relative;
      padding-bottom: 24px;
      border-bottom: 1px solid #DCDFE6;

      .oneClickOperation {
        position: absolute;
        top: 0px;
        right: 0px;
      }

      .value {
        width: 200px;
        margin-right: 12px;

        /deep/.el-select {
          width: 100%;
        }

        /deep/.el-date-editor {
          width: 100%;
        }
      }
    }

    .quantityStatistics {
      margin-top: 24px;

      p {
        margin-bottom: 6px;
      }

      .total {
        display: flex;
        flex-wrap: wrap;

        .item {
          margin-right: 36px;

          span {
            color: #B4272D;
          }
        }
      }
    }
  }


  .table {
    max-height: 600px;
    overflow: auto;
    position: relative;

    ol {
      display: flex;
      height: 50px;
      position: sticky;
      top: 0;
      left: 0;
      z-index: 99;

      li {
        text-align: center;
      }
    }

    ul {
      display: flex;
      padding: 20px 0;
      background-color: #fff;

      &:nth-last-child(1) {
        border-bottom: 0;
      }

      li {
        padding: 12px 3px;

        .template {
          width: 100%;
          overflow: hidden;

          .row {
            line-height: 20px;
            margin-bottom: 5px;
          }
        }
      }
    }

    li {


      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex2 {
      flex: 2;
    }

    .flex3 {
      flex: 3.5;
    }

    .option {
      padding: 20px;
      border-radius: 6px;
      background-color: #F6F6F6;

      .row {
        display: flex;
        line-height: 40px !important;
        margin-bottom: 12px;

        .label {
          width: 100px;
        }

        .input {
          width: 80px;
          margin: 0 10px;
        }

        .num {
          width: 60px;
          margin-right: 10px;
          color: #2C96E7;
        }

        .del {
          width: 40px;
          font-size: 24px;

          i {
            color: #B4272D;
            cursor: pointer;
          }
        }
      }
    }
  }

  .btn {
    background-color: #F8F8F8;
    text-align: right;
    position: sticky;
    bottom: 0;
    left: 0;
    padding: 24px;
  }

  .footer {
    display: flex;
    margin-top: 24px;
    padding: 24px;
    background-color: #F8F8F8;

    .label {
      margin-right: 5px;
    }

    .text {
      width: 1000px;
      margin-right: 48px;

      /deep/.el-textarea__inner {
        height: 200px;
      }
    }

    .file {
      flex: 1;
      display: flex;

      /deep/.el-upload-dragger {
        width: 100px;
        height: 40px;
      }

      .file-list {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 24px;

        i {
          font-size: 100px;
          margin-right: 20px;
          color: #b4272d;
        }
      }
    }
  }


  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>
